import type { ReactNode } from "react";

const benefits: { icon: ReactNode; title: string; description: string }[] = [
  {
    icon: (
      <svg className="w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
    title: "AI-First Transformation for Every Role",
    description:
      "Future-proof your Engineering, Marketing, Leadership, & Business teams with cutting-edge AI skills.",
  },
  {
    icon: (
      <svg className="w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
      </svg>
    ),
    title: "Customization That Fits Your Organization",
    description:
      "AI training built to your specifications, combining online and offline learning to meet your unique organization's goals.",
  },
  {
    icon: (
      <svg className="w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: "Train with the Top 1% of AI Practitioners",
    description:
      "Your team learns directly from leading practitioners — AI pioneers who deliver actionable insights and real results.",
  },
  {
    icon: (
      <svg className="w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: "Your Trusted L&D Partner",
    description:
      "We support your Learning & Development as an extension of your team or a full outsourced partner.",
  },
];

export default function B2BBenefitsSection() {
  return (
    <section className="flex font-fira flex-col gap-8 animate-[fade-in_0.4s_ease-out_both]">
      <h3 className="text-white font-semibold text-lg">
        Why learn with us?
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {benefits.map((b, i) => (
          <div
            key={b.title}
            className="bg-[#282828] border border-white/10 rounded-2xl p-5 transition-shadow hover:shadow-[0_0_20px_rgba(255,255,255,0.04)] animate-[fade-in_0.4s_ease-out_both]"
            style={{ animationDelay: `${(i + 1) * 80}ms` }}
          >
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0">
              {b.icon}
            </div>
            <h4 className="text-white font-medium mt-3 text-sm leading-snug">
              {b.title}
            </h4>
            <p className="text-secondary text-sm mt-1.5 leading-relaxed">
              {b.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
